module.exports = __webpack_public_path__ + "img/logo.28b66256.jpg";